import React from 'react';
import { HiScale } from 'react-icons/hi2';
import AnalysisNavItem from './AnalysesNavItem';
import './AnalysesNavList.css';
import { useTranslation } from 'react-i18next';

type Props = {
    variant?: 'home' | 'analyses' | 'compact';
};

const AnalysesNavList = ({ variant = 'home' }: Props) => {
    const { t } = useTranslation('analyses');

    const homeAnalyses = [
        {
            title: t('attendance.analysis'),
            path: 'dochazka',
            icon: <span className='material-symbols-rounded'>person_check</span>
        },
        {
            title: t('comparison.councilMembers'),
            path: 'porovnani_zastupitelu',
            icon: <HiScale size={24} />
        },
        {
            title: t('unity.partiesVoting'),
            path: 'nejednotnost',
            icon: <span className='material-symbols-rounded'>zoom_out_map</span>
        },
        {
            title: t('cohesion.voting'),
            path: 'koheze',
            icon: <span className='material-symbols-rounded'>zoom_in_map</span>
        }
    ];

    const analyses = homeAnalyses;
    const additionalAnalyses = [
        // To be extended with additional analyses
    ];

    const isAnalysisVariant = variant === 'analyses';
    const isCompact = variant === 'compact';
    if (isAnalysisVariant) {
        homeAnalyses.forEach((item) => {
            additionalAnalyses.push(item);
        });
    }

    return (
        <div className={`analyses-nav${isAnalysisVariant ? ' analyses-variant' : ''}${isCompact ? ' compact' : ''}`}>
            {analyses.map((item, index) => (
                <AnalysisNavItem key={index} {...item} compact={isCompact} />
            ))}
        </div>
    );
};

export default AnalysesNavList;
